export enum AutoCompleteRule {
  Manual = 'manual',
  OnInviteSent = 'on_invite_sent',
  OnDocumentUploaded = 'on_document_uploaded',
  OnPropertyCreated = 'on_property_created',
}

export enum TaskGroup {
  Onboarding = 'onboarding',
  DueDiligenceReview = 'due_diligence_review',
  OfferStrategy = 'offer_strategy',
  ContingencyReview = 'contingency_review',
}

export enum TaskRole {
  Advisor = 'advisor',
  Client = 'client',
  Both = 'both',
}

export interface Task {
  id: string;
  dealId: string;
  /** Set for property-scoped tasks, including the listing-specific MLS check in Onboarding. */
  listingId?: string;
  group: TaskGroup;
  groupLabel: string;
  groupOrder: number;
  taskOrder: number;
  title: string;
  subtitle?: string;
  role: TaskRole;
  bookingNamespace?: string;
  autoCompleteRule: AutoCompleteRule;
  completedAt?: number;
  completedBy?: string;
  createdAt: number;
  updatedAt: number;
}

export interface TaskGroupView {
  group: TaskGroup;
  groupLabel: string;
  groupOrder: number;
  tasks: Task[];
}

export const groupTasks = (tasks: Task[]): TaskGroupView[] => {
  const grouped = new Map<TaskGroup, TaskGroupView>();
  for (const task of tasks) {
    let entry = grouped.get(task.group);
    if (!entry) {
      entry = {
        group: task.group,
        groupLabel: task.groupLabel,
        groupOrder: task.groupOrder,
        tasks: [],
      };
      grouped.set(task.group, entry);
    }
    entry.tasks.push(task);
  }
  const result = Array.from(grouped.values());
  for (const g of result) {
    g.tasks.sort((a, b) => a.taskOrder - b.taskOrder);
  }
  result.sort((a, b) => a.groupOrder - b.groupOrder);
  return result;
};
